import * as React from 'react';
import { SVGProps } from 'react';

const IcPower = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1.5C6.2 1.5 1.5 6.2 1.5 12S6.2 22.5 12 22.5 22.5 17.8 22.5 12 17.8 1.5 12 1.5Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M8.73 19.24a.82.82 0 0 1-.49-.16.845.845 0 0 1-.27-1.06l2.24-4.69-1.92-.02a.846.846 0 0 1-.59-1.45l6.98-6.85c.29-.29.75-.33 1.09-.08.34.24.45.69.27 1.06l-2.24 4.69 1.92.02a.846.846 0 0 1 .59 1.45L9.33 19a.84.84 0 0 1-.59.24h-.01Zm.65-7.22 1.54.02c.29 0 .56.15.71.4.16.25.17.55.04.82l-1.44 3.02 4.39-4.31-1.54-.02c-.29 0-.56-.15-.71-.4a.854.854 0 0 1-.05-.82l1.44-3.03-4.39 4.31.01.01Z"
    />
  </svg>
);
export default IcPower;
